module.exports = __webpack_public_path__ + "images/emoji/paperclip.ff5bd6c51507c6723171.png";